import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MeetingDetailClient } from './MeetingDetailClient';
import { useParams } from 'react-router-dom';

export default function MeetingDetailPage() {
  const { id } = useParams<{ id: string }>();

  return (
    <ProtectedRoute>
      {id && <MeetingDetailClient meetingId={id} />}
    </ProtectedRoute>
  );
}
